import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './guards/auth.guard';
import { AuthGuardLogged } from './guards/authLogged.guard';
import { PageNotFoundComponent } from './layouts/page-not-found/page-not-found.component';
import { VerificationTeamComponent } from './pages/pengaturan/pages/teams/pages/verification-team/verification-team.component';
import { VerificationSuccessComponent } from './pages/pengaturan/pages/teams/pages/verification-success/verification-success.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ActivateRegisterComponent } from './pages/register/activate-register/activate-register.component';
import { RegisterSuccessComponent } from './pages/register/register-success/register-success.component';
import { RegisterComponent } from './pages/register/register.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '#',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./layouts/main-layout/main-layout.module').then(
        (m) => m.MainLayoutModule
      ),
  },
  {
    path: 'login',
    component: AuthLayoutComponent,
    canActivate: [AuthGuardLogged],
    loadChildren: () =>
      import('./layouts/auth-layout/auth-layout.module').then(
        (m) => m.AuthLayoutModule
      ),
  },
  {
    path: '',
    loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'registration',
    component: RegisterComponent,
    canActivate: [AuthGuardLogged],
  },
  {
    path: 'register-success',
    component: RegisterSuccessComponent,
    canActivate: [AuthGuardLogged],
  },
  {
    path: 'activate',
    component: ActivateRegisterComponent,
    canActivate: [AuthGuardLogged],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [AuthGuardLogged],
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [AuthGuardLogged],
  },
  {
    path: 'verification',
    component: VerificationTeamComponent,
    canActivate: [AuthGuardLogged],
  },
  {
    path: 'verification-success',
    component: VerificationSuccessComponent,
    canActivate: [AuthGuardLogged],
  },
  { path: '**', component: PageNotFoundComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [AuthGuard, AuthGuardLogged],
  exports: [RouterModule],
})
export class AppRoutingModule {}
